import { render, staticRenderFns } from "./CompareSlider.vue?vue&type=template&id=4ec830d3&scoped=true&"
import script from "./CompareSlider.vue?vue&type=script&lang=ts&"
export * from "./CompareSlider.vue?vue&type=script&lang=ts&"
import style0 from "./CompareSlider.vue?vue&type=style&index=0&id=4ec830d3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec830d3",
  null
  
)

export default component.exports